import { defineComponent as _defineComponent } from 'vue';
import { toRef, computed, getCurrentInstance, ref } from 'vue';
import BoxSingleTop from '@blade-sxp/monitoring-center/pages/components/box-single-top.vue';
import TaskPlayer from '@blade-sxp/monitor/components/player/sei-player.vue';
import { useSingleVideo } from '@blade-sxp/monitoring-center/pages/preview/utils/useSingleVideo';
import { useMonitoringStore } from '@blade-sxp/monitoring-center/store/index';
import { useBoxSize } from '@blade-sxp/monitoring-center/pages/preview/utils/useBoxSize';
export default /*#__PURE__*/ _defineComponent({
    __name: 'video-box-single',
    props: {
        detail: null,
        size: null
    },
    emits: ['deviceDrop', 'deviceDragOver', 'deviceDragleave'],
    setup(__props, { emit }) {
        const props = __props;
        /**
         * 单个视频框 组件引入注解
         * 引入方式：<VideoBoxSingle v-for="(item, index) in videoDetailArr" :key="index" :detail="item" v-show="showSingleBox(index)" />
         * 支持的props如下：
         * detail {VideoItem} 当前视频框数据
         */
        const store = useMonitoringStore();
        const vm = getCurrentInstance()?.proxy;
        const fullscreen = computed(() => store.fullscreen);
        const boxPlayer = ref(null);
        const detail = toRef(props, 'detail');
        const { getContentStyle } = useBoxSize(boxPlayer);
        const boxStyle = computed(() => getContentStyle());
        const { changeTask, drop, dragover, dragleave } = useSingleVideo(emit);
        return { __sfc: true, store, vm, emit, fullscreen, boxPlayer, props, detail, getContentStyle, boxStyle, changeTask, drop, dragover, dragleave, BoxSingleTop, TaskPlayer };
    }
});
